const paymentsMethod = [
  {
    key: "cod",
    image: "",
    name: "COD",
    active: false,
  },
  {
    key: "bank",
    image: "",
    name: "Chuyển Khoản",
    active: false,
  },
  {
    key: "momo",
    image: "",
    name: "Thanh toán Momo",
    active: false,
  },
  {
    key: "vnpay",
    image: "",
    name: "Vnpay",
    active: false,
  },
  {
    key: "zalopay",
    image: "",
    name: "ZaloPay",
    active: false,
  },
];

export default paymentsMethod;
